import { AppRouter } from './router';
import { Toaster } from '@/components/ui/Toast';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { LoginPage } from '@/pages/LoginPage';
import { AiChatProvider } from '@/sections/ai-chat/AiChatProvider';

function AuthGate() {
  const { user, loading } = useAuth();

  // Show a minimal loading screen while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-8 h-8 border-2 border-indigo-200 border-t-indigo-600 rounded-full animate-spin" />
      </div>
    );
  }

  // Not authenticated → show login
  if (!user) {
    return <LoginPage />;
  }

  // Authenticated → show the app
  return (
    <AiChatProvider>
      <AppRouter />
      <Toaster />
    </AiChatProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AuthGate />
    </AuthProvider>
  );
}
